import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, SERVICES, SEO_TERMS, DEFENCE_SERVICE } from "./marketingData";

export function MarketingFooter() {
  return (
    <footer className="bg-[#1A1A18] text-[#F9F8F6]/85" data-testid="marketing-footer">
      {/* On-page SEO term cloud */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
          <div className="text-xs font-semibold tracking-widest uppercase text-[#D4A373] mb-5">
            India's trusted transporter for
          </div>
          <div className="flex flex-wrap gap-2.5" data-testid="seo-terms">
            {SEO_TERMS.map((t) => (
              <span key={t}
                className="rounded-full border border-white/12 bg-white/[0.03] px-3.5 py-1.5 text-xs text-[#F9F8F6]/80 hover:border-[#C84B31]/50 hover:text-white transition-colors">
                {t}
              </span>
            ))}
          </div>
          <p className="mt-6 text-sm text-[#F9F8F6]/75 max-w-4xl leading-relaxed">
            Indian Transport Organisation (ITO) is a leading transporter and cargo transportation
            company in India, serving every pincode by land and air. From air-suspension trailers and
            explosive vans to ODC, defence, drones and construction machinery — we move it safely,
            fast and reliably, nationwide since 1972.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <img src="/ito-logo.png" alt="ITO" className="w-12 h-12 object-contain" />
            <div className="leading-none">
              <div className="font-heading font-black text-white text-base">INDIAN TRANSPORT</div>
              <div className="font-heading font-black text-[#C84B31] text-base">ORGANISATION</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed max-w-xs">
            Moving India's heaviest and most critical cargo — machinery, defence equipment,
            tanks and ODC — by road and air, to every pincode.
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs font-semibold tracking-widest uppercase text-[#D4A373] mb-5">Services</div>
          <ul className="space-y-3">
            {[...SERVICES, DEFENCE_SERVICE].map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="text-sm hover:text-white transition-colors"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs font-semibold tracking-widest uppercase text-[#D4A373] mb-5">Reach us</div>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <Phone className="w-4 h-4 text-[#C84B31] shrink-0 mt-0.5" />
              <a href={CONTACT.phoneHref} className="hover:text-white transition-colors" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 text-[#C84B31] shrink-0 mt-0.5" />
              <a href={CONTACT.emailHref} className="hover:text-white transition-colors break-all" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-[#C84B31] shrink-0 mt-0.5" />
              <span>{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#F9F8F6]/75">
          <span>© {new Date().getFullYear()} Indian Transport Organisation. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 justify-center sm:justify-end">
            <Link to="/services" className="hover:text-white transition-colors" data-testid="footer-services">
              Services
            </Link>
            <Link to="/air-suspension-trailer-transporter" className="hover:text-white transition-colors" data-testid="footer-air-suspension">
              Air Suspension Trailers
            </Link>
            <Link to="/low-bed-trailer-transporter" className="hover:text-white transition-colors" data-testid="footer-low-bed">
              Low-Bed Trailers
            </Link>
            <Link to="/odc-heavy-haul-transporter" className="hover:text-white transition-colors" data-testid="footer-odc">
              ODC Transport
            </Link>
            <Link to="/insights" className="hover:text-white transition-colors" data-testid="footer-insights">
              Insights
            </Link>
            <Link to="/app" className="hover:text-white transition-colors" data-testid="footer-login">
              Employee Login →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
